import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT_E_COMMERCE } from './route-names'

/**
 * Bouygues authentication routes with full paths
 * These should be imported directly in checkout/routes.ts without nesting
 */
export const bouyguesAuthRoutes: RouteRecordRaw[] = [
  // Desktop auth route with BouyguesWebRoot wrapper
  {
    path: 'f2/services/bouygues-telecom',
    component: () =>
      import('~/scopes/checkout/flows/e-commerce/pages/BouyguesWebRoot/BouyguesWebRoot.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
    children: [
      {
        path: 'auth',
        name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.AUTH,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/BouyguesAuthentication/BouyguesAuthentication.vue'),
        meta: {
          layout: 'minimal',
          owners: ['bot-squad-b2cservices-front'],
        },
      },
    ],
  },
  // Webview auth route with BouyguesWebviewRoot wrapper
  {
    path: 'f2/webview/services/bouygues-telecom',
    component: () =>
      import('~/scopes/checkout/flows/e-commerce/pages/BouyguesWebviewRoot/BouyguesWebviewRoot.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
    children: [
      {
        path: 'auth',
        name: CHECKOUT_E_COMMERCE.WEBVIEW.SERVICES.BOUYGUES.AUTH,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/BouyguesAuthentication/BouyguesAuthentication.vue'),
        meta: {
          layout: 'minimal',
          owners: ['bot-squad-b2cservices-front'],
        },
      },
    ],
  },
]

/**
 * Bouygues flow routes (nested under CheckoutFlow)
 * These should be imported in e-commerce routes with relative paths
 */
export const bouyguesFlowRoutes: RouteRecordRaw[] = [
  // Desktop routes - use Vue Router navigation
  {
    path: 'services/bouygues-telecom',
    name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.ROOT,
    redirect: { name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.SIGN_UP },
    component: () =>
      import('~/scopes/checkout/flows/e-commerce/pages/BouyguesWebRoot/BouyguesWebRoot.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
    children: [
      {
        path: 'sign-up',
        name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.SIGN_UP,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/BouyguesSignUp/BouyguesSignUp.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
        },
      },
      {
        path: 'phoneline-setup',
        name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.PHONELINE_SETUP,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/BouyguesPhonelineSetup/BouyguesPhonelineSetup.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
        },
      },
      {
        path: 'not-eligible',
        name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.NOT_ELIGIBLE,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/BouyguesPhonelineSetup/components/NotEligible/NotEligible.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
        },
      },
    ],
  },

  // Webview routes - use deep link navigation
  {
    path: 'webview/services/bouygues-telecom',
    name: CHECKOUT_E_COMMERCE.WEBVIEW.SERVICES.BOUYGUES.ROOT,
    redirect: { name: CHECKOUT_E_COMMERCE.WEBVIEW.SERVICES.BOUYGUES.SIGN_UP },
    component: () =>
      import('~/scopes/checkout/flows/e-commerce/pages/BouyguesWebviewRoot/BouyguesWebviewRoot.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
    children: [
      {
        path: 'sign-up',
        name: CHECKOUT_E_COMMERCE.WEBVIEW.SERVICES.BOUYGUES.SIGN_UP,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/BouyguesSignUp/BouyguesSignUp.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
        },
      },
      {
        path: 'phoneline-setup',
        name: CHECKOUT_E_COMMERCE.WEBVIEW.SERVICES.BOUYGUES.PHONELINE_SETUP,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/BouyguesPhonelineSetup/BouyguesPhonelineSetup.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
        },
      },
      {
        path: 'not-eligible',
        name: CHECKOUT_E_COMMERCE.WEBVIEW.SERVICES.BOUYGUES.NOT_ELIGIBLE,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/BouyguesPhonelineSetup/components/NotEligible/NotEligible.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
        },
      },
    ],
  },
]
